<script setup lang="ts">
import { computed } from 'vue'

import { useBlockades } from '@desktop/views/Relation/Sports/composables'
import { injectPocketIncidentsConfig } from '@desktop/views/Relation/Sports/provide-inject'

import PocketIncidentButton from './PocketIncidentButton.vue'
import PocketIncidentsMoreButton from './PocketIncidentsMoreButton.vue'

// inject
const { morePocketIncidents, pocketIncidents, blockedPocketIncidentsMap } =
  injectPocketIncidentsConfig()

// composables
const { isIncidentBlocked } = useBlockades()

// computed
const moreButtonDisabled = computed(() => {
  if (!blockedPocketIncidentsMap) return false

  return morePocketIncidents?.every(({ incidentId }) =>
    isIncidentBlocked(incidentId, blockedPocketIncidentsMap),
  )
})
</script>

<template>
  <div class="flex items-center gap-1.5">
    <div class="flex w-full items-center gap-2">
      <template
        v-for="{ incidentId, title } in pocketIncidents"
        :key="incidentId"
      >
        <slot
          :incidentId
          :title
        >
          <PocketIncidentButton :incidentId>
            {{ title }}
          </PocketIncidentButton>
        </slot>
      </template>
    </div>
    <PocketIncidentsMoreButton :disabled="moreButtonDisabled" />
  </div>
</template>
